<template>
  <swiper-container class="flex w-full bg-[#00395a] text-white" :slidesPerView="1" :loop="true" :modules="modules" :autoplay="{
    delay: 5000,
    pauseOnMouseEnter: true,
  }" :speed="1200" ref="swiperRefPromotionalBanner">
    <swiper-slide v-for="(item, index) in announcements" :key="index" class="flex flex-col items-center justify-center">
      <p class="text-base sm:text-lg p-4">{{ item.bannertext || item }}</p>
    </swiper-slide>
  </swiper-container>
</template>

<script>
import { Navigation } from "swiper/modules";
import "swiper/css/navigation";
import "swiper/css/pagination";
export default {
  props: ['announcements'],

  data() {
    return {
      imageIndex: 0,
      modules: [Navigation],
    };
  },

}
</script>